module.exports = __webpack_public_path__ + "icons.d7c639084f684d66a1bc66855d193ed8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/icons.svg
// module id = 31
// module chunks = 0